/**************************************************
 * Nombre:       Home_Lineas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {motion, useScroll, useTransform} from "framer-motion";
import iso from '../../../Recursos/iso.svg'
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";


const Home_Lineas = () => {
    const speed = 1;
    const {scrollY} = useScroll();
    const x = useTransform(scrollY, (value) => -value * speed);
    const y = useTransform(scrollY, (value) => value * speed);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{overflowX: 'hidden', py: 0}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{overflowX: 'hidden'}}>
                <Grid
                    component={motion.div}
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{
                        backgroundColor: theme.palette.primary.main,
                        py: 1.5,
                        zIndex: 2,
                        minWidth: 4500,
                        maxLines: 1
                    }}
                    style={{x: x, transitionTimingFunction: "spring(1 100 10 10)", transition: "transform 3s"}}
                >

                    {lista.map((item, index) => {
                        return (
                            <Typography
                                key={index+'45sd'}
                                sx={{
                                    color: '#fff',
                                    mx: 0.2,
                                    fontSize: 16,
                                    maxLines: 1,
                                    fontWeight: 300,
                                    pl: 2,
                                    letterSpacing: 8,
                                    fontFamily: NEGRITA
                                }}>{item} <span><img src={iso} width={20} height={'auto'}
                                                     style={{marginTop: 4, marginBottom: -4, marginLeft: 12}}/></span>
                            </Typography>
                        )
                    })}


                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Lineas

const lista = ['ESCUELA DE ADMINISTRACION Y NEGOCIOS', 'ESCUELA DE ESTETICA Y BIENESTAR HUMANO', 'ESCUELA DE ADMINISTRACION Y NEGOCIOS', 'ESCUELA DE SISTEMAS Y TECNOLOGIA', 'ESCUELA D CIENCIAS DE LA SALUD', 'ESCUELA DE DEPORTE Y ACTIVIDAD FISICA']